(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yp-flower-product-row"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('yp-product-tabs')) {
  customElements.define('yp-product-tabs', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const tabs = [...this.querySelectorAll('[data-product-tab]')];
      const panels = [...this.querySelectorAll('[data-product-panel]')];
      if (!tabs.length) return;
      const activate = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
        });
        panels.forEach(panel => {
          panel.hidden = panel.dataset.productPanel !== tabs[index].dataset.productTab;
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', panel.id + '-tab');
          if (!panel.hidden) panel.scrollLeft = 0;
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index), { signal: this.abort.signal });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); activate(next, true); }
        }, { signal: this.abort.signal });
      });
      this.querySelector('.yp-product-tabs__controls').hidden = false;
      activate(0);
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yp-frame-variant-style"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const variantBlock = document.querySelector('.product__section-content__block--variant-picker');
    if (!variantBlock) return;

    const containers = variantBlock.querySelectorAll('.swatches__container');

    containers.forEach((container) => {
      const title = container.querySelector('.swatches__option-name');
      if (!title) return;

      const optionText = title.textContent.toLowerCase();
      if (optionText.includes('frame size')) {
        container.dataset.ypOption = 'frame-size';
      }
      if (optionText.includes('frame color')) {
        container.dataset.ypOption = 'frame-color';
      }

      const selected = title.querySelector('.swatches__option-value');
      if (selected) selected.textContent = selected.textContent.replace('8X10', '8x10');

      container.querySelectorAll('.swatches__form--input').forEach((input) => {
        input.addEventListener('change', () => {
          const active = title.querySelector('.swatches__option-value');
          if (active) active.textContent = input.value.replace('8X10', '8x10');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yp-home-flower-cards"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (root.dataset.carouselReady === 'true') return;
    const track = root.querySelector('[data-flower-track]');
    const originals = [...root.querySelectorAll('.yp-home-flower-card')];
    const previousButton = root.querySelector('[data-flower-prev]');
    const nextButton = root.querySelector('[data-flower-next]');
    if (!track || !originals.length || !previousButton || !nextButton) return;
    root.dataset.carouselReady = 'true';
    const count = originals.length;
    const looping = count > 1;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const { signal } = controller;
    const clone = (card) => {
      const copy = card.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('tabindex', '-1');
      [copy, ...copy.querySelectorAll('*')].forEach((element) => {
        element.removeAttribute('id');
        element.removeAttribute('data-shopify-editor-block');
      });
      copy.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => element.setAttribute('tabindex', '-1'));
      return copy;
    };
    if (looping) {
      track.prepend(...originals.map(clone));
      track.append(...originals.map(clone));
    }
    const cards = [...track.querySelectorAll('.yp-home-flower-card')];
    const start = looping ? count : 0;
    let active = start;
    let target = null;
    let frame = 0;
    let timer = 0;
    let touching = false;
    const logical = (index) => ((index - start) % count + count) % count;
    const offset = (index) => {
      const rect = cards[index].getBoundingClientRect();
      return track.scrollLeft + rect.left + rect.width / 2 - track.getBoundingClientRect().left - track.clientWidth / 2;
    };
    const update = () => {
      frame = 0;
      const center = track.getBoundingClientRect().left + track.clientWidth / 2;
      let distance = Infinity;
      cards.forEach((card, index) => {
        const rect = card.getBoundingClientRect();
        const delta = Math.abs(rect.left + rect.width / 2 - center);
        if (delta < distance) { distance = delta; active = index; }
      });
      cards.forEach((card, index) => card.classList.toggle('is-current', logical(index) === logical(active)));
      previousButton.disabled = !looping;
      nextButton.disabled = !looping;
    };
    const goTo = (index, instant = false) => {
      target = Math.max(0, Math.min(index, cards.length - 1));
      track.scrollTo({ left: offset(target), behavior: instant || reducedMotion.matches ? 'instant' : 'smooth' });
      if (instant || reducedMotion.matches) update();
    };
    const settle = () => {
      clearTimeout(timer);
      if (touching) return;
      update();
      target = null;
      if (looping && (active < start || active >= start + count)) {
        const index = start + logical(active);
        track.scrollTo({ left: offset(index), behavior: 'instant' });
        active = index;
        update();
      }
    };
    track.addEventListener('scroll', () => {
      if (!frame) frame = requestAnimationFrame(update);
      clearTimeout(timer);
      timer = setTimeout(settle, 160);
    }, { passive: true, signal });
    track.addEventListener('scrollend', settle, { signal });
    track.addEventListener('pointerdown', () => { touching = true; target = null; }, { passive: true, signal });
    const release = () => { if (touching) { touching = false; clearTimeout(timer); timer = setTimeout(settle, 160); } };
    window.addEventListener('pointerup', release, { passive: true, signal });
    window.addEventListener('pointercancel', release, { passive: true, signal });
    const step = (direction) => {
      let from = target === null ? active : target;
      if (from + direction < 0 || from + direction >= cards.length) {
        from = start + logical(from);
        goTo(from, true);
      }
      goTo(from + direction);
    };
    previousButton.addEventListener('click', () => step(-1), { signal });
    nextButton.addEventListener('click', () => step(1), { signal });
    track.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home') goTo(start);
      else if (event.key === 'End') goTo(start + count - 1);
      else step(event.key === 'ArrowRight' ? 1 : -1);
    }, { signal });
    track.addEventListener('focusin', (event) => {
      const index = cards.indexOf(event.target.closest('.yp-home-flower-card'));
      if (index >= 0) goTo(index);
    }, { signal });
    root.addEventListener('shopify:block:select', (event) => {
      const index = originals.indexOf(event.target.closest('.yp-home-flower-card'));
      if (index >= 0) goTo(start + index, true);
    }, { signal });
    const observer = new ResizeObserver(() => { goTo(start + logical(active), true); target = null; });
    observer.observe(track);
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(root)) return;
      observer.disconnect();
      controller.abort();
      clearTimeout(timer);
      cancelAnimationFrame(frame);
    }, { signal });
    goTo(start + (count >= 3 && window.matchMedia('(min-width: 750px)').matches ? 1 : 0), true);
    target = null;
  };
  document.querySelectorAll('[data-yp-flower-focus]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-yp-flower-focus]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yp-home-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('yp-hero-slider')) {
  customElements.define('yp-hero-slider', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); clearTimeout(this.timer); this.observer?.disconnect();
      this.abort = new AbortController(); const opts = {signal:this.abort.signal};
      this.slides = [...this.querySelectorAll('[data-yp-slide]')];
      this.controls = this.querySelector('.yp-hero-controls');
      if (!this.slides.length || !this.controls) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches || Boolean(window.Shopify?.designMode);
      this.inView = false; this.hovered = false; this.focused = false; this.index = 0;
      this.controls.replaceChildren();
      this.dots = this.slides.map((slide, i) => {
        slide.id = this.id + '-slide-' + i;
        slide.setAttribute('role','group'); slide.setAttribute('aria-roledescription','slide');
        slide.setAttribute('aria-label',(i + 1) + ' of ' + this.slides.length);
        const dot = document.createElement('button'); dot.type = 'button'; dot.className = 'yp-hero-dot';
        dot.setAttribute('aria-label','Show slide ' + (i + 1)); dot.setAttribute('aria-controls',slide.id);
        dot.addEventListener('click',() => this.show(i),opts); this.controls.append(dot); return dot;
      });
      this.toggle = document.createElement('button'); this.toggle.type = 'button'; this.toggle.className = 'yp-hero-toggle';
      this.toggle.addEventListener('click',() => {this.paused = !this.paused;this.updateToggle();this.schedule();},opts);
      this.controls.append(this.toggle); this.controls.hidden = this.slides.length < 2;
      this.updateToggle(); this.show(0);
      this.addEventListener('pointerenter',e => {if(e.pointerType==='mouse'){this.hovered=true;this.schedule();}},opts);
      this.addEventListener('pointerleave',() => {this.hovered=false;this.schedule();},opts);
      this.addEventListener('focusin',() => {this.focused=true;this.schedule();},opts);
      this.addEventListener('focusout',e => {this.focused=this.contains(e.relatedTarget);this.schedule();},opts);
      document.addEventListener('visibilitychange',() => this.schedule(),opts);
      this.motion.addEventListener('change',e => {if(e.matches){this.paused=true;this.updateToggle();this.schedule();}},opts);
      this.addEventListener('keydown',e => {
        if(e.target.matches('input,textarea,select')) return;
        if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();const dotFocused=this.dots.includes(e.target);this.show(this.index+(e.key==='ArrowRight'?1:-1));if(dotFocused)this.dots[this.index].focus();}
      },opts);
      this.addEventListener('touchstart',e => {clearTimeout(this.timer);this.start=[e.touches[0].clientX,e.touches[0].clientY];},{...opts,passive:true});
      this.addEventListener('touchend',e => {
        if(this.start){const dx=e.changedTouches[0].clientX-this.start[0],dy=e.changedTouches[0].clientY-this.start[1];if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy)*1.5)this.show(this.index+(dx<0?1:-1));}
        this.start=null;this.schedule();
      },{...opts,passive:true});
      this.addEventListener('touchcancel',() => {this.start=null;this.schedule();},opts);
      this.addEventListener('shopify:block:select',e => {const i=this.slides.findIndex(s=>s.contains(e.target)||s===e.target);if(i>=0){this.paused=true;this.updateToggle();this.show(i);}},opts);
      this.observer = new IntersectionObserver(entries => {this.inView=entries[0].isIntersecting;this.schedule();},{threshold:0});this.observer.observe(this);
    }
    updateToggle() {
      const label=this.paused?'Play slideshow':'Pause slideshow';this.toggle.setAttribute('aria-label',label);this.toggle.title=label;
      this.toggle.innerHTML=this.paused?'<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 2l10 6-10 6z"/></svg>':'<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 2h3v12H3zm7 0h3v12h-3z"/></svg>';
    }
    show(i) {
      this.index=(i+this.slides.length)%this.slides.length;this.slides.forEach((s,n)=>{s.hidden=n!==this.index;});
      this.dots.forEach((d,n)=>d.setAttribute('aria-current',String(n===this.index)));
      const next=this.slides[(this.index+1)%this.slides.length].querySelector('img');if(next)next.loading='eager';this.schedule();
    }
    schedule() {clearTimeout(this.timer);if(this.slides.length<2||this.paused||this.hovered||this.focused||!this.inView||document.hidden)return;this.timer=setTimeout(()=>this.show(this.index+1),5000);}
    disconnectedCallback() {clearTimeout(this.timer);this.abort?.abort();this.observer?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yp-keepsake-examples"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = root => {
    if (root.dataset.compareReady) return;
    root.dataset.compareReady = 'true';
    root.querySelectorAll('[data-yp-compare]').forEach(compare => {
      const range = compare.querySelector('input');
      const render = () => compare.style.setProperty('--reveal', range.value + '%');
      range.addEventListener('input', render);
      let pointer = null;
      const move = e => {
        const rect = compare.getBoundingClientRect();
        range.value = Math.round(Math.max(0, Math.min(100, (e.clientX - rect.left) / rect.width * 100)));
        render();
      };
      range.addEventListener('pointerdown', e => {
        if (e.button !== 0) return;
        e.stopPropagation(); e.preventDefault();
        pointer = e.pointerId; range.setPointerCapture(pointer); range.focus({preventScroll:true}); move(e);
      });
      range.addEventListener('pointermove', e => { if (e.pointerId === pointer) { e.stopPropagation(); move(e); } });
      const end = () => { pointer = null; };
      range.addEventListener('pointerup', end); range.addEventListener('pointercancel', end);
      range.addEventListener('keydown', e => e.stopPropagation());
    });
    const list = root.querySelector('.yp-examples__list');
    const prev = root.querySelector('[data-example-prev]');
    const next = root.querySelector('[data-example-next]');
    if (root.hasAttribute('data-yp-centered-loop') && list.children.length >= 3) {
      const cards = [...list.children];
      let active = 0;
      const renderCards = () => {
        cards.forEach((card, index) => {
          card.classList.toggle('is-current', index === active);
          card.classList.toggle('is-previous', index === (active - 1 + cards.length) % cards.length);
          card.classList.toggle('is-next', index === (active + 1) % cards.length);
        });
        prev.disabled = false;
        next.disabled = false;
        root.dataset.activeExample = String(active + 1);
      };
      prev.addEventListener('click', () => { active = (active - 1 + cards.length) % cards.length; renderCards(); });
      next.addEventListener('click', () => { active = (active + 1) % cards.length; renderCards(); });
      root.addEventListener('shopify:block:select', event => {
        const index = cards.indexOf(event.target.closest('.yp-examples__card'));
        if (index >= 0) { active = index; renderCards(); }
      });
      renderCards();
    } else {
      const state = () => { if (prev) prev.disabled = list.scrollLeft < 2; if (next) next.disabled = list.scrollLeft >= list.scrollWidth - list.clientWidth - 2; };
      const step = direction => { const card = list.querySelector('.yp-examples__card'); if (card) list.scrollBy({left:direction * (card.offsetWidth + 24),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}); };
      prev?.addEventListener('click', () => step(-1)); next?.addEventListener('click', () => step(1));
      list.addEventListener('scroll', state, {passive:true});
      const resize = new ResizeObserver(state); resize.observe(list); state();
      root.addEventListener('shopify:block:select', e => { const card = e.target.closest('.yp-examples__card'); if(card) list.scrollTo({left:card.offsetLeft,behavior:'instant'}); });
      document.addEventListener('shopify:section:unload', e => { if(e.target.contains(root)) resize.disconnect(); }, {once:true});
    }
    const items = [...root.querySelectorAll('[data-example-open]')]; const dialog = root.querySelector('[data-example-lightbox]');
    if (!dialog || !items.length) return;
    let current = 0;
    const show = i => { current=(i+items.length)%items.length;const img=items[current].querySelector('img');dialog.querySelector('[data-lightbox-image]').src=img.currentSrc||img.src;dialog.querySelector('[data-lightbox-image]').alt=img.alt;dialog.querySelector('[data-lightbox-caption]').textContent=items[current].closest('.yp-examples__card').querySelector('h3')?.textContent||''; };
    items.forEach((button,i)=>button.addEventListener('click',()=>{show(i);dialog.showModal();}));
    dialog.querySelector('[data-example-close]').addEventListener('click',()=>dialog.close());
    dialog.querySelector('[data-lightbox-prev]').addEventListener('click',()=>show(current-1));
    dialog.querySelector('[data-lightbox-next]').addEventListener('click',()=>show(current+1));
    dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
    dialog.addEventListener('keydown',e=>{if(e.key==='ArrowLeft')show(current-1);if(e.key==='ArrowRight')show(current+1);});
  };
  document.querySelectorAll('[data-yp-comparison-section]').forEach(initialize);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-yp-comparison-section]').forEach(initialize));
})();

(() => {
  let records = [], roots = [], selected = 'all';
  const category = card => {
    const value = (card.querySelector('.yp-examples__cta')?.getAttribute('href') || '') + ' ' + (card.querySelector('h3')?.textContent || '');
    if (/forever-in-bloom|forget.me.not/i.test(value)) return 'forget';
    if (/white.rose|gentle-goodbye/i.test(value)) return 'rose';
    if (/sunflower|sunny-soul/i.test(value)) return 'sunflower';
    if (/peon|another-year/i.test(value)) return 'peony';
    if (/dais|joy-that-needs/i.test(value)) return 'daisy';
    if (/cherry/i.test(value)) return 'cherry';
    return '';
  };
  const apply = value => {
    selected = value;
    records.forEach(({card}) => {card.hidden = value !== 'all' && category(card) !== value;});
    roots[0]?.querySelectorAll('[data-flower]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.flower === value)));
  };
  const restore = () => {
    records.forEach(({card,list}) => {card.hidden = false;list.append(card);});
    roots.forEach(root => {root.classList.remove('yp-examples--filter-primary','yp-examples--filter-continuation');const filter=root.querySelector('[data-flower-filter]');if(filter)filter.hidden=true;});
    records=[];
  };
  const setup = () => {
    restore();
    roots = [...document.querySelectorAll('.yp-examples--gallery')].filter(root => root.querySelector('[data-flower-filter]'));
    if (!roots.length) return;
    const destination=roots[0].querySelector('.yp-examples__list');
    roots.forEach((root,index) => {
      const list=root.querySelector('.yp-examples__list');
      [...list.children].filter(card=>card.matches('.yp-examples__card')).forEach(card=>{records.push({card,list});destination.append(card);});
      root.classList.add(index?'yp-examples--filter-continuation':'yp-examples--filter-primary');
    });
    const filter=roots[0].querySelector('[data-flower-filter]');filter.hidden=false;
    if(!filter.dataset.ready){filter.dataset.ready='true';filter.addEventListener('click',event=>{const button=event.target.closest('[data-flower]');if(button)apply(button.dataset.flower);});}
    apply(selected);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
  document.addEventListener('shopify:section:unload',restore);
  document.addEventListener('shopify:section:load',setup);
  document.addEventListener('shopify:section:reorder',setup);
  document.addEventListener('shopify:block:select',event=>{if(records.some(({card})=>card===event.target||card.contains(event.target)))apply('all');});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yp-order-updates"] && !Shopify.designMode) return;
  try {
    
(function(){function openCarrier(carrier,number){var value=(number||"").trim();if(!value){return}var encoded=encodeURIComponent(value);var urls={usps:"https://tools.usps.com/go/TrackConfirmAction?tLabels="+encoded,ups:"https://www.ups.com/track?tracknum="+encoded,fedex:"https://www.fedex.com/fedextrack/?trknbr="+encoded};window.open(urls[carrier],"_blank","noopener")}document.addEventListener("click",function(event){var button=event.target.closest("[data-yp-tracking-buttons] button");if(!button){return}var group=button.closest("[data-yp-tracking-buttons]");var input=document.getElementById(group?group.getAttribute("data-input-id"):"");openCarrier(button.getAttribute("data-carrier"),input?input.value:"")})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yp-product-page-polish"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const content = document.querySelector('.product__section-content');
    const template = document.querySelector('#yp-atf-restore-template');
    if (!content || !template || content.querySelector('.yp-atf-restore')) return;

    content.prepend(template.content.firstElementChild.cloneNode(true));
  })();

  } catch(e) { console.error(e); }
})();
})();
